/**
 * External dependencies
 */
import { IconControl, IconDisplay } from '~cartzillagb/components'
import { isValidIconValue, getIconArray } from '~cartzillagb/components/icon-control'
import { whiteIfDarkBlackIfLight } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import {
	IconButton, ToggleControl, Toolbar, withFocusOutside, Popover,
} from '@wordpress/components'
import {
	applyFormat, registerFormatType, removeFormat,
} from '@wordpress/rich-text'
import { BlockControls } from '@wordpress/block-editor'
import { __ } from '@wordpress/i18n'
import { Component } from '@wordpress/element'
import { compose } from '@wordpress/compose'
import domReady from '@wordpress/dom-ready'
import { dispatch, select } from '@wordpress/data'

const createApplyFormat = ( icon ) => {
	if ( ! icon ) {
		return removeFormat(
			icon,
			'czgb/icon',
		)
	}

	return applyFormat(
		icon,
		{
			type: 'czgb/icon',
			className: `czgb-icon ${ icon }`,

		}
	)
}

class iconButton extends Component {
	constructor() {
		super( ...arguments )
		this.state = {
			isOpen: false,
		}
		this.handleFocusOutside = this.handleFocusOutside.bind( this )
	}

	handleFocusOutside() {
		this.setState( {
			isOpen: false,
		} )
	}

	render() {
		 const {
	       	value, size, additionalClass, onChange, setAttributes
	    } = this.props

	    const selectedIcon = getIconArray( value )
	    const isValidIcon = isValidIconValue( value )

	    const prefix = isValidIcon && selectedIcon[0][0]

	    const icon = ( isValidIcon && selectedIcon ) && classnames( [
	        prefix === 'czi' && `${prefix} czi-${selectedIcon[1]}`,
	        prefix !== 'czi' && `${prefix} fa-${selectedIcon[1]}`,
	        size,
	        additionalClass
	    ] )

		return (
			<BlockControls>
				<Toolbar className="cartzillagb-components-toolbar">
					<IconButton
						className="components-button components-icon-button components-toolbar__control"
						icon="smiley"
						aria-haspopup="true"
						tooltip={ __( 'Icon', i18n ) }
						onClick={ () => this.setState( { isOpen: ! this.state.isOpen } ) }
					/>
					{ this.state.isOpen &&
						<Popover
							position="bottom center"
							className="components-cartzillagb-icon__popover"
							focusOnMount="container"
						>
							<div className="components-cartzillagb-icon__inner">
								<div className="czgb-icon-format">
									<IconControl
										value={ icon }
										onChange={ icon => {
											onChange( createApplyFormat( value, icon ) )
										} }

									/>
								</div>
							</div>
						</Popover>
					}
				</Toolbar>
			</BlockControls>
		)
	}
}

registerFormatType(
	'czgb/icon', {
		title: __( 'icon', i18n ),
		tagName: 'i',
		className: 'czgb-icon',
		edit: compose(
			withFocusOutside,
		)( iconButton ),
		attributes: {
			style: 'style',
		},
	}
)

domReady( () => {
	// Turn off EditorsKit features to prevent duplicates.
	if ( ! select( 'core/edit-post' ).isFeatureActive( 'disableEditorsKitColorsFormats' ) ) {
		dispatch( 'core/edit-post' ).toggleFeature( 'disableEditorsKitColorsFormats' )
	}
	if ( ! select( 'core/edit-post' ).isFeatureActive( 'disableEditorsKiticonFormats' ) ) {
		dispatch( 'core/edit-post' ).toggleFeature( 'disableEditorsKiticonFormats' )
	}
} )
